module.exports = __webpack_public_path__ + "assets/media/navigations-map.f35a68ec.svg";